import { createKey } from './createKey';

const keyHandler = createKey('picklist');

export const PicklistServiceKeys = {
  key: keyHandler.key,
  get: keyHandler.createMethod(),
};
